import React from "react";

import Plot from "./Plot";


export default function () {
    return <Plot/>;
}